import Keycloak from "keycloak-js";
import dayjs from "dayjs";

let keycloakInstance = null;

export const getKeycloak = () => keycloakInstance;

export default {
  install(
    Vue,
    { keycloakConfig, initOptions = {}, onReady = () => {}, eventHandlers = {} }
  ) {
    let enableKcLogging = process.env.VUE_APP_KEYCLOAK_LOG === "true";
    let enableUpdateToken =
      process.env.VUE_APP_KEYCLOAK_UPDATE_TOKEN === "true";

    // event bus globale
    let eventBus = new Vue();
    Vue.prototype.$eventBus = eventBus;

    keycloakInstance = new Keycloak(keycloakConfig);

    // assegna callback se presenti
    let events = [
      "onAuthSuccess",
      "onAuthError",
      "onAuthRefreshSuccess",
      "onAuthRefreshError",
      "onAuthLogout",
      "onTokenExpired"
    ];

    events.forEach(eventName => {
      keycloakInstance[eventName] = (...args) => {
        // chiamata della callback se definita
        if (typeof eventHandlers[eventName] === "function") {
          eventHandlers[eventName](...args);
        }

        // emit dell'evento sull'eventBus
        eventBus.$emit(eventName, ...args);
      };
    });

    keycloakInstance
      .init({
        onLoad: process.env.VUE_APP_KEYCLOAK_ONLOAD,
        silentCheckSsoRedirectUri:
          window.location.origin + "/silent-check-sso.html",
        checkLoginIframe: false,
        enableLogging: enableKcLogging,
        ...initOptions
      })
      .then(authenticated => {
        Vue.prototype.$keycloak = keycloakInstance;

        if (enableKcLogging) {
          printTokenInfo(
            "ACCESS",
            keycloakInstance.token,
            keycloakInstance.tokenParsed
          );
          printTokenInfo(
            "REFRESH",
            keycloakInstance.refreshToken,
            keycloakInstance.refreshTokenParsed
          );
        }

        // add updateToken mechanism only if authenticated and if required
        if (authenticated && enableUpdateToken) {
          let tokenRefreshInterval = 60; // in seconds
          setInterval(() => {
            keycloakInstance
              .updateToken(300) // effettua il refresh se l'attuale token scade entro 5 minutes
              .then(refreshed => {
                if (refreshed) {
                  // token refreshed
                  if (enableKcLogging) {
                    printActionInfo("ACCESS token refreshed");
                    printTokenInfo(
                      "NEW ACCESS",
                      keycloakInstance.token,
                      keycloakInstance.tokenParsed
                    );
                    printTokenInfo(
                      "NEW REFRESH",
                      keycloakInstance.refreshToken,
                      keycloakInstance.refreshTokenParsed
                    );
                  }
                } else {
                  // do nothing, token still valid
                  if (enableKcLogging) {
                    printActionInfo("ACCESS token still valid");
                  }
                }
              })
              .catch(() => {
                // errore durante l'aggiornamento dell'access token, per cui va eseguito il logout
                if (enableKcLogging) {
                  printActionInfo("Error during ACCESS token refresh");
                }
                Vue.prototype.$eventBus.$emit("onAuthLogout");
              });
          }, tokenRefreshInterval * 1000); // viene eseguito il check ogni 'tokenRefreshInterval' seconds
        }

        onReady(keycloakInstance, authenticated);
      })
      .catch(err => {
        console.error(
          "[KEYCLOAK] -> errore durante l'inizializzazione di Keycloak",
          err
        );
      });

    // metodi utili disponibili globalmente
    Vue.prototype.$kcLogin = (options = {}) => keycloakInstance.login(options);
  }
};

const printTokenInfo = (type, t, tp) => {
  if (t && tp) {
    // console.log(`${type} token`, t);
    let iatDate = dayjs(tp?.iat * 1000)
      .tz("Europe/Rome")
      .format("DD-MM-YYYY HH:mm:ss");
    console.log(`${type} token issued at`, iatDate);
    let expDate = dayjs(tp?.exp * 1000)
      .tz("Europe/Rome")
      .format("DD-MM-YYYY HH:mm:ss");
    console.log(`${type} token expired at`, expDate);
  }
};

const printActionInfo = type => {
  let now = dayjs().tz("Europe/Rome").format("DD-MM-YYYY HH:mm:ss");
  console.log(`${type} at`, now);
};
